/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';

import {AppSharedModule} from '../app-shared.module';
import {CodemirrorFieldComponent} from './codemirror-field.component';

@NgModule({
  imports: [AppSharedModule],
  declarations: [CodemirrorFieldComponent],
  exports: [CodemirrorFieldComponent]
})
export class CodemirrorModule {
}
